<a class="navbar-brand" [routerLink]="['/']">
    <img [ngClass]="{'img-destop':!imgmovil}" [style.height.rem]="height?height:2" [src]="url_desktop">
    <img *ngIf="!imgmovil" class="img-movil animated fadeIn" [style.height.rem]="height?height:2" [src]="url_movil ">
</a>